<app-navbar-style-one></app-navbar-style-one>

<div class="home-slider owl-carousel owl-theme">
    <div class="slider-item" 
        style="background-image: url('../../../assets/img/home2/order-online.jpg');">
        <div class="d-table">
            <div class="d-table-cell">
                <div class="container">
                    <div class="slider-content">
                        <h1>Order Apps</h1>
                        <p>"Craving wings or sandwiches? Order online and we'll have it hot and ready!"</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<section class="orderAppsSection mt-2">
    <div class="container-fluid px-3">
        <div class="row" *ngIf="!isLoading">
            <div class="col-lg-3 col-md-6 col-sm-6 col-12 pt-3 text-center" *ngFor="let item of orderApps;let i = index" [class.even-item]="i%2">
                <div class="customCard">
                    <img [src]="item.image" [alt]="item.title" class="img-fluid" alt="Apps">
                    <a [href]="item.url" target="_blank" class="btn btn-primary">{{item.title}}</a>
                </div>
            </div>
        </div>
        <div class="row" *ngIf="isLoading">
            <div class="col-12 text-center">
                <div class="spinner-grow" role="status">
                    <span class="visually-hidden">Loading...</span>
                </div>
            </div>
        </div>
    </div>
</section>

<app-footer-style-two></app-footer-style-two>